import { ButtonGroup, Button, FormControl, Select, MenuItem, FormHelperText, Typography, Grid, Slider, SelectChangeEvent, styled, IconButton } from "@mui/material";
import MuiInput from '@mui/material/Input';
import { useState } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import HomeIcon from '@mui/icons-material/Home';
import { gitLink, blogLink } from "../Utiltiy/SortSetting";
const Input = styled(MuiInput)`
  width: 42px;
`;
export default function SortingBtnGroup(props: any) {
    const {arraySize,ARRAY_SIZE_MAX,setArraySize,setAnimationSpeed,animationSpeed,ANIMATION_SPEED_MAX,
        resetArray,onSortBtnClick,mergeSort,quickSort,quickSortRandomPivot,heapSort,bubbleSort} = props;
    const [isSorting, setIsSorting] = useState<boolean>(false);
    const rows = [];
    for(let i=5;i<=ANIMATION_SPEED_MAX;i+=5){
        rows.push(i);
        if(20<=i) i += 5;
    } 

    const handleChange = (event: SelectChangeEvent) => {
        setAnimationSpeed(parseInt(event.target.value));
      };
    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        setArraySize(newValue);
    };
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setArraySize(event.target.value === '' ? 10 : Number(event.target.value));
    };
    const handleBlur = () => {
        if (arraySize < 10) {
            setArraySize(10);
        } else if (arraySize > ARRAY_SIZE_MAX) {
            setArraySize(ARRAY_SIZE_MAX);
        }
    };

    return (
        <ButtonGroup variant="outlined" aria-label="outlined primary button group" sx={{ p: 2 }}>
            <Button>
                <IconButton target="_blank" href={gitLink}><GitHubIcon/></IconButton>
                <IconButton target="_blank" href={blogLink}><HomeIcon/></IconButton>
            </Button> 
            <Button sx={{ width: 250 }} disabled={isSorting}>
                <FormControl size="small" sx={{ m: 1, minWidth: 50 }}>
                    <Select
                        value={String(animationSpeed)}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    {rows.map((value, idx) => (
                        <MenuItem value={value} key={idx}>{value}</MenuItem>
                    ))}
                    </Select>
                    <FormHelperText>Animation Speed</FormHelperText>
                </FormControl>
            </Button>
            <Button sx={{ width: 250 }} disabled={isSorting}>
                <Typography id="input-slider" gutterBottom>
                    Array Size
                </Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs>
                        <Slider 
                            value={arraySize}
                            onChange={handleSliderChange}
                            aria-labelledby="input-slider"
                            step={1}
                            marks
                            min={10}
                            max={ARRAY_SIZE_MAX}
                        />
                    </Grid>
                    <Grid item>
                        <Input
                            value={arraySize}
                            type='number'
                            size="medium"
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            inputProps={{
                            step: 10,
                            max: ARRAY_SIZE_MAX,
                            min: 10,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                            }}
                        />
                    </Grid>
                </Grid>
            </Button>
            <Button onClick={() => resetArray()} disabled={isSorting}>New Array</Button>
            <Button onClick={() => onSortBtnClick(setIsSorting,mergeSort)} disabled={isSorting}>Merge Sort</Button>
            <Button onClick={() => onSortBtnClick(setIsSorting, quickSort)} disabled={isSorting}>Quick Sort</Button>
            <Button onClick={() => onSortBtnClick(setIsSorting, quickSortRandomPivot)} disabled={isSorting}>QS random pivot</Button>
            <Button onClick={() => onSortBtnClick(setIsSorting, heapSort)} disabled={isSorting}>Heap Sort</Button>
            <Button onClick={() => onSortBtnClick(setIsSorting, bubbleSort)} disabled={isSorting}>Bubble Sort</Button>
        </ButtonGroup>
    )
}